import { render, staticRenderFns } from "./StaffTable.vue?vue&type=template&id=60292701&scoped=true"
import script from "./StaffTable.vue?vue&type=script&lang=js"
export * from "./StaffTable.vue?vue&type=script&lang=js"
import style0 from "./StaffTable.vue?vue&type=style&index=0&id=60292701&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60292701",
  null
  
)

export default component.exports